<div class="groups mb-3" *transloco="let translate">
    <div class="headerDiv" [class.mat-mdc-elevation-z8]="activeCategory">
        <h1 class="transactions" [textContent]="activeCategory?.length > 0 ? translate(activeCategory | pascalToCamel) : ''"></h1>
        <strong class="categoryName" *ngIf="selectedLeftNav" [textContent]="selectedLeftNav.name"></strong>
        <div class="assetSearch">
            <mat-form-field *transloco="let translate">
                <mat-label>{{ 'Search ' + ((selectedLeftNav?.name ? selectedLeftNav?.name : activeCategory || 'Transactions') | pascalToCamel) }}</mat-label>
                <input matInput type="text" [(ngModel)]="filterAppName" (keyup)="searchPackage($event)">
                <material-button
                                 matSuffix
                                 buttonType="icon"
                                 size="small"
                                 color="default"
                                 (buttonClicked)="clearSearchApp()"
                                 [prefixIcon]="filterAppName ? 'close' : 'search'"
                                 prefixIconType="material">
                </material-button>
            </mat-form-field>
        </div>
    </div>
    <div class="others">
        <ng-container *ngIf="showTaxonomy && (selectedLeftNav?.id === 'utilities' || activeCategory === 'utilities')">
            <ng-container *ngTemplateOutlet="taxonomyTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="activeCategory === 'utilities' && packages?.length > 0">
            <div class="otherpackages mat-elevation-z8" *ngFor="let package of packages; trackBy: trackById">
                <app-left-nav-apps-template (bridgeDialogOpen)="bridgeDialogOpen.emit($event)" (closeMenu)="closeMatmenu()" [package]="package" [serviceId]="package?.serviceId" [selectedLeftNav]="selectedLeftNav"></app-left-nav-apps-template>
            </div>
        </ng-container>
        <div class="otherpackages mat-elevation-z8" *ngIf="activeCategory !== 'utilities' && packages?.length > 0">
            <ng-container *ngFor="let package of packages; trackBy: trackById">
                <app-left-nav-apps-template (bridgeDialogOpen)="bridgeDialogOpen.emit($event)" (closeMenu)="closeMatmenu()" [package]="package" [serviceId]="package.serviceId" [selectedLeftNav]="selectedLeftNav"></app-left-nav-apps-template>
            </ng-container>
        </div>
        <div class="otherpackages mat-elevation-z8" *ngIf="apps?.length > 0">
            <div class="package">
                <material-button
                                 buttonType="icon"
                                 [size]="'small'"
                                 prefixIcon="web_stories"
                                 [classList]="['packageIcon']"></material-button>
                <span class="packageName" [textContent]="translate('category_' + (activeCategory|| selectedLeftNav.id))"></span>
            </div>
            <ng-container *ngFor="let app of apps; trackBy: trackById">
                <app-left-nav-apps-template (bridgeDialogOpen)="bridgeDialogOpen.emit($event)" (closeMenu)="closeMatmenu()" [serviceId]="app.serviceId"></app-left-nav-apps-template>
            </ng-container>
        </div>
        <ng-container *ngIf="packages?.length === 0 && apps?.length === 0 && filterAppName.length === 0">
            <div class="noTransactionsFoundContainer">
                <div class="noTransactionsFound" [textContent]="translate('No Apps Subscribed.')">
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="packages?.length === 0 && apps?.length === 0 && filterAppName.length > 0">
            <div class="noTransactionsFoundContainer">
                <div class="noTransactionsFound" [textContent]="translate('No Apps Found.')">
                </div>
            </div>
        </ng-container>
        <ng-template #taxonomyTemplate>
            <div class="m-[10px] p-[10px] rounded bg-white mat-elevation-z8" *ngIf="showTaxonomy">
                <div class="packageApps">
                    <div class="groupTitleLayout relatedApps" [title]="translate('Taxonomy Map')" [routerLink]="'/organizations/' + currentOrganizationId + '/taxonomy/maps'" (click)="closeMatmenu()">
                        <div class="groupsContent">
                            <div class="groupIconCircle">
                                <mat-icon class="material-symbols-outlined reconIcon"> account_tree </mat-icon>
                            </div>
                        </div>
                        <span class="groupName" [textContent]="'Taxonomy Map'"></span>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
